import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import bootstrapImage from '../../images/cardpageimages/technicalcourse/bootstrapimage.png';
import IntroVideos from "../../componants/introvideos";
import BootstrapModule from "../../componants/allCourseModule/TechnicalCourseModule/BootstrapModule";

function BootstrapCourse() {
  return (
    <>
      <Header />
      <BannerForAll
        title="BOOTSTRAP FULL COURSE"
        text="Our Bootstrap Full Course will teach you how to quickly design and customize responsive websites using the world's most popular front-end framework. You'll learn to create mobile-first web designs using Bootstrap's grid system, components, and utilities. This course is perfect for beginners who want to master responsive web development and streamline their workflow with Bootstrap."
        imageone={bootstrapImage}
        imagetwo={bootstrapImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="BOOTSTRAP"
      />
      <BootstrapModule />
      <Footer />
    </>
  );
}

export default BootstrapCourse;
